import React, { useEffect } from "react";
import "./offer-banner.css";
import { getAllBanner } from "../../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";

const Offer_banner = () => {
  const dispatch = useDispatch();

  const allbanners = useSelector((state) => state.home.allbanners);

  useEffect(() => {
    dispatch(getAllBanner({ banner_type_id: 1 }));
  }, [dispatch]);

  const imageUrl = allbanners?.image
    ? process.env.REACT_APP_IMAGE_URL + allbanners.image
    : null;

  const videoUrl = allbanners?.video
    ? process.env.REACT_APP_IMAGE_URL + allbanners.video
    : null;

  const mediaUrl = allbanners?.image
    ? process.env.REACT_APP_IMAGE_URL + allbanners.image
    : null;

  const isVideo = /\.(mp4|webm|ogg)$/i.test(mediaUrl || "");

  return (
    <section className="Offer_banner_sec">
      <div className="container">
        <div className="offerbanerdiv">
          {isVideo ? (
            <video
              className="offerbanner"
              src={mediaUrl}
              autoPlay
              loop
              muted
              playsInline
            />
          ) : mediaUrl ? (
            <img className="offerbanner" src={mediaUrl} alt="Offer Banner" />
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default Offer_banner;
